module.exports = __webpack_public_path__ + "static/cta-4b1afe9ed78133ba03e77c2dfc5a7ce2.jpg";